import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

function ButtonPrimary(props) {
  const Light = () => (
    <div
      className={`${props.gray ? "bg-gray-500" : "bg-green-500"}
        ${
          props.light ? "block" : "hidden"
        } absolute -top-[1px] h-[4px] w-[70%] rounded-sm`}
    />
  );
  const Button = () => {
    return (
      <>
        <button
          className={`${
            props.gray
              ? "bg-brand-gray-3 disabled:btn-gray-disabled"
              : "btn-blue disabled:btn-blue-disabled"
          } button-text relative flex items-center justify-center disabled:cursor-not-allowed ${
            props.className
          }`}
          onClick={props.onClick}
          disabled={props.disabled}
          id={props.id}
        >
          <Light />
          {props.children}
        </button>
      {props.tooltip && (
        <Tooltip
          anchorId={props.id}
          content={props.tooltip}
          className="tooltip"
          place="top"
          type="dark"
          effect="solid"
        />
      )
      }
      </>
    );
  };

  const getHiperLinkStateColor = () =>
  `${
    props.gray
      ? `${
          props.disabled ? "btn-gray-disabled cursor-not-allowed" : "bg-brand-gray-3"
        }`
      : `${
          props.disabled ? "btn-blue-disabled cursor-not-allowed" : "btn-blue"
        }`
  } `;

  const HiperLink = () => {
    return (
      <a
      className={`${getHiperLinkStateColor()} button-text relative flex items-center justify-center ${
        props.className
      }`}
      onClick={props.onClick}
      href={props.href}
    >
      <Light />
      {props.children}
    </a>
    );
  };
  return <>{props.href ? HiperLink() : Button()}</>;
}

ButtonPrimary.defaultProps = {
  light: false,
  gray: false,
  disabled: false,
};

export default ButtonPrimary;
